/**
 * sensors data event javascript
 */

/*********************** events start ***********************/
$(function () {
// 注册登录事件
    $('.header__action-item--account').click(function () {
        // 注册结果
        $('.form_register_btn').click(function () {
            localStorage.setItem('sensors_is_register', 1);
            localStorage.setItem('sensors_is_login', 1);
        });
        $('#register-form-error').on('DOMNodeInserted', function () {
            sensors.track('RegisterResult', {
                register_email: $('#create_customer input[name="customer[email]"]').val(),
                is_success: false,
                fail_reason: $(this).text()
            });
            localStorage.removeItem('sensors_is_register');
            localStorage.removeItem('sensors_is_login');
        });
        // 登录结果
        $('#header_customer_login .form_login_btn').click(function () {
            localStorage.setItem('sensors_is_login', 1);
        });
    });

    if (window.location.pathname.includes("/login")) {
        if ($("#login-form-error").text().length > 0) {
            sensors.track('LoginResult', {
                login_email: $('#create_customer input[name="customer[email]"]').val(),
                is_success: false,
                fail_reason: $("#login-form-error").text()
            });
            localStorage.removeItem('sensors_is_register');
            localStorage.removeItem('sensors_is_login');
        }
        $("button[type='submit'].form__submit").click(() => {
            localStorage.setItem('sensors_is_login', 1);
        })
    }

// 订阅结果
    $('#footer-newsletter button[type="submit"]').click(function () {
        let subscribEmail = $('#footer-newsletter input[name="contact[email]"]').val();
        if (subscribEmail != '' && subscribEmail.indexOf('@') > 0) {
            sensors.track('SubscribResult', {
                subscribe_email: subscribEmail
            });
        }
    });

// 取消加购 - minicart
    $('#mini-cart').on('click', 'a.mini-cart__quantity-remove', function () {
        sensorHandleRemoveFromCart($(this).parents('.mini-cart__line-item'), $('#mini-cart input.quantity-selector__value').val())
    });
    $('#mini-cart').on('change', 'input.quantity-selector__value', function () {
        let adjustQty = $(this).data('current-value') - $(this).val();
        if (adjustQty > 0) {
            sensorHandleRemoveFromCart($(this).parents('.mini-cart__line-item'), adjustQty)
        } else {
            let $this = $(this).parents(".mini-cart__line-item")
            let refererCookie = getRefererPageCookie($this.attr("data-productid"))
            trackWithProductInfo("AddToCart", {
                ...refererCookie,
                sku_id: $this.attr('data-sku_id'),
                sku_name: $this.find('.mini-cart__product-title').html(),
                sku_price: $this.find('.line-item__price').html().replace(/\$|,|£|€/g, '') * 1,
                commodity_tag: $this.attr('data-commodity_tag'),
                sku_quantity: Math.abs(adjustQty)
            })
        }
    });
    $('#mini-cart').on('click', 'button.quantity-selector__button', function () {
        if ($(this).index() == 0) {
            sensorHandleRemoveFromCart($(this).parents('.mini-cart__line-item'), 1)
        } else {
            let $this = $(this).parents(".mini-cart__line-item")
            let refererCookie = getRefererPageCookie($this.attr("data-productid"))
            trackWithProductInfo("AddToCart", {
                ...refererCookie,
                sku_id: $this.attr('data-sku_id'),
                sku_name: $this.find('.mini-cart__product-title').html(),
                sku_price: $this.find('.line-item__price').html().replace(/\$|,|£|€/g, '') * 1,
                commodity_tag: $this.attr('data-commodity_tag'),
                sku_quantity: 1
            })
        }
    });
// 课程播放
    if (window.location.href.indexOf('pages/kol-reviews') > 0) {
        $('.video-wrapper__image').on('click', function () {
            let courceBroadcastParams = {
                course_id: "",
                course_name: $(this).parents('.cus-video-item').find('.video-title').text().replace(/\n|\s{2,}/gi, ''),
                course_url: $(this).parent().siblings('iframe').data('src'),
                broadcast_duration: "",
                course_type: "",
                course_chapter: ""
            };
            sensors.track('CourceBroadcast', courceBroadcastParams);
        });
    }


// 取消加购 - cart页面
    $('#shopify-section-cart-template').on('click', 'a.line-item__quantity-remove', function () {
        sensorHandleRemoveFromCart($(this).parents('tr.line-item'), $('#shopify-section-cart-template input.quantity-selector__value').val())
    });
    $('#shopify-section-cart-template').on('change', 'input.quantity-selector__value', function () {
        let adjustQty = $(this).data('current-value') - $(this).val();
        if (adjustQty > 0) {
            sensorHandleRemoveFromCart($(this).parents('tr.line-item'), adjustQty)
        } else {
            let $this = $(this).parents(".line-item--stack")
            let refererCookie = getRefererPageCookie($this.attr("data-productid"))
            trackWithProductInfo("AddToCart", {
                ...refererCookie,
                sku_id: $this.attr('data-sku_id'),
                sku_name: $this.find('.line-item__title').html(),
                sku_price: $this.data("price") / 100,
                commodity_tag: $this.attr('data-commodity_tag'),
                sku_quantity: Math.abs(adjustQty)
            })
        }
    });
    $('#shopify-section-cart-template').on('click', 'button.quantity-selector__button', function () {
        if ($(this).index() == 0) {
            sensorHandleRemoveFromCart($(this).parents('tr.line-item'), 1)
        } else {
            let $this = $(this).parents(".line-item--stack")
            let refererCookie = getRefererPageCookie($this.attr("data-productid"))
            trackWithProductInfo("AddToCart", {
                ...refererCookie,
                sku_id: $this.attr('data-sku_id'),
                sku_name: $this.find('.line-item__title').html(),
                sku_price: $this.data("price") / 100,
                commodity_tag: $this.attr('data-commodity_tag'),
                sku_quantity: 1
            })
        }
    });

    function sensorHandleRemoveFromCart(parentObj, quantity) {
        let removeFromCartParams = {
            sku_id: parentObj.data('sku_id'),
            sku_name: parentObj.data('sku_name'),
            sku_price: Number((parentObj.data('sku_price') + '').replace(/€|,|\./, '')) / 100,
            commodity_tag: parentObj.data('commodity_tag'),
            sku_quantity: quantity,
        };
        // sensors.track('RemoveFromCart', removeFromCartParams);
        trackWithProductInfo('RemoveFromCart', removeFromCartParams)
    }

    function navSensors(dom) {
        let href = dom.getAttribute("href")
        if (href.indexOf('redirect') > -1) {
            href = href.split('redirect=')[1]
        }
        RantionSetCookie(href, JSON.stringify({
            referer_page_type: "导航栏",
            referer_page: window.location.href,
            click_id: sensors.quick('getAnonymousID') + new Date().getTime() + href
        }))
    }

    if (window.location.pathname === "/") {
        //   资源位点击埋点,PC与移动都一致
        $(".for_collection_list").on("click", ".for_collection_item", function (e) {
            // e.preventDefault()
            // e.stopPropagation()
            let $this = $(e.target).parents(".for_collection_item")
            let idx = $this.parent().children().index($this)
            // let productId = $this.attr("data-productid")


            let [sku_id, sku_name, sku_price, commodity_tag, productId] = [$this.attr("data-skuid"), $this.find(".for_vendor_title a").html().trim(), $this.data("price") / 100, $this.attr("data-tag"), $this.attr("data-productid")]

            let scookie = {
                mkt_page: "首页",
                mkt_area: $this.parents("[data-section-type]").find("h2.section_title").text(),
                mkt_position_number: idx + 1 + '',
                mkt_material_id: sku_id,
                mkt_material_name: sku_name,
                sku_price,
                commodity_tag
            }

            // console.log(scookie);
            RantionSetCookie(productId, JSON.stringify({
                referer_page_type: "资源位",
                referer_page: window.location.href,
                mkt_page: scookie.mkt_page,
                mkt_area: scookie.mkt_area,
                mkt_position_number: scookie.mkt_position_number,
                click_id: sensors.quick('getAnonymousID') + new Date().getTime() + $(this).attr("data-skuid")
            }))

            sensors.track("mktClick", scookie)

            if ($(e.target).text().trim() == 'In den Warenkorb') {
                let refererCookie = getRefererPageCookie(productId)
                trackWithProductInfo("AddToCart", {
                    ...refererCookie,
                    sku_id,
                    sku_name,
                    sku_price,
                    commodity_tag,
                    sku_quantity: 1
                })
                // return
            }
            // window.location.href=$this.find(".for_vendor_image a").data("href")
        })

        // 商品资源位曝光埋点
        // var productExposure = new IntersectionObserver(enters => {
        //     enters.forEach(item=>{
        //         if (item.isIntersecting && !item.target.classList.contains("Exposured")) {
        //             let $this = $(item.target)
        //             let idx=$this.parent().children().index($this)
        //             sensors.track("mktExposure",{
        //                 mkt_page: "首页",
        //                 mkt_area: $this.parents("[data-section-type]").find("h2.section_title").text(),
        //                 mkt_position_number: idx + 1+'',
        //                 mkt_material_id:$this.attr("data-skuid"),
        //                 mkt_material_name: $this.find(".for_vendor_title a").html().trim(),
        //                 sku_price:$this.data("price") / 100,
        //                 commodity_tag:$this.attr("data-tag")
        //             })
        //             $this.addClass("Exposured")
        //             setTimeout(()=>{
        //               $this.removeClass("Exposured")
        //             },60000)
        //         }
        //     })

        // }, { threshold: [0.8] })
        // $(".for_collection_list .for_collection_item").each((i,dom)=>{
        //   productExposure.observe(dom)
        // })

        // second_banner资源位点击
        $(".index-section.banner-section").on("click", (e) => {
            // e.preventDefault()
            let $this = $(e.target).parents(".banner")
            sensors.track("mktClick", {
                mkt_page: "首页",
                mkt_area: $this.attr("data-mkt_area"),
                mkt_position_number: $this.attr("data-index"),
                mkt_material_id: $this.find(".box a").attr("href"),
                mkt_material_name: document.title,
                sku_price: "",
                commodity_tag: ""
            })
        })

        // second_banner资源位曝光埋点
        // var bannerExposure = new IntersectionObserver(enters => {
        //     if (enters[0].isIntersecting && !enters[0].target.classList.contains("Exposured")) {
        //       let $this = $(enters[0].target)
        //     //   let $this = $(e.target).parents(".banner")
        //       sensors.track("mktExposure",{
        //           mkt_page:"首页",
        //           mkt_area:$this.attr("data-mkt_area"),
        //           mkt_position_number:$this.attr("data-index"),
        //           mkt_material_id:$this.find(".box a").attr("href"),
        //           mkt_material_name:document.title,
        //           sku_price:"",
        //           commodity_tag:""
        //       })
        //       $this.addClass("Exposured")
        //       setTimeout(()=>{
        //         $this.removeClass("Exposured")
        //       },60000)
        //     }
        // }, { threshold: [0.8] })
        // $(".index-section.banner-section .banner").each((i,dom)=>{
        //   bannerExposure.observe(dom)
        // })


        $(".one_image").on("click", (e) => {
            // e.preventDefault()
            let $this = $(e.target).parents(".one_image")
            sensors.track("mktClick", {
                mkt_page: "首页",
                mkt_area: $this.attr("data-mkt_area"),
                mkt_position_number: $this.attr("data-index"),
                mkt_material_id: $this.find(".container.hidden-phone a").attr("href"),
                mkt_material_name: $this.find(".section_title").text() || document.title,
                sku_price: "",
                commodity_tag: ""
            })
            // window.location.href=$this.find(".container.hidden-phone a").attr("href")
        })

        // one_image资源位曝光
        // var oneImageExposure = new IntersectionObserver(enters => {
        //     if (enters[0].isIntersecting && !enters[0].target.classList.contains("Exposured")) {
        //       let $this = $(enters[0].target)
        //     //   let $this = $(e.target).parents(".one_image")
        //       sensors.track("mktExposure",{
        //           mkt_page:"首页",
        //           mkt_area:$this.attr("data-mkt_area"),
        //           mkt_position_number:$this.attr("data-index"),
        //           mkt_material_id:$this.find(".container.hidden-phone a").attr("href"),
        //           mkt_material_name:$this.find(".section_title").text()||document.title,
        //           sku_price:"",
        //           commodity_tag:""
        //       })
        //       $this.addClass("Exposured")
        //       setTimeout(()=>{
        //         $this.removeClass("Exposured")
        //       },60000)
        //     }
        // }, { threshold: [0.8] })
        // $(".one_image").each((i,dom)=>{
        //   oneImageExposure.observe(dom)
        // })

        $(".silm-main").on("click", ".slim-grid-item", (e) => {
            // e.preventDefault()
            // console.log(132);
            let $this = $(e.target).parents(".slim-grid-item")
            let idx = $(".silm-main .slim-grid-item").index($this)
            sensors.track("mktClick", {
                mkt_page: "首页",
                mkt_area: "main_collection",
                mkt_position_number: idx + 1 + '',
                mkt_material_id: $this.find("a").attr("href"),
                mkt_material_name: $this.find(".slim-grid-item-title").text(),
                sku_price: "",
                commodity_tag: ""
            })
            // window.location.href=$this.find("a").attr("href")
        })

        // 第二期埋点
        $(".three_video").on("click", ".video_product", (e) => {
            let $this = $(e.target).parents(".video_product")
            let idx = $(".three_video .video_product").index($this) + 1 + ""
            sensors.track("mktClick", {
                mkt_page: "首页",
                mkt_area: "fast_entrance",
                mkt_position_number: idx,
                mkt_material_id: "",
                mkt_material_name: $this.find(".video_product_title").text().trim(),
                sku_price: "",
                commodity_tag: ""
            })
        })
        $(".view_more_courses a").click((e) => {
            sensors.track("mktClick", {
                mkt_page: "首页",
                mkt_area: "fast_entrance",
                mkt_position_number: "4",
                mkt_material_id: $(e.target).attr("href"),
                mkt_material_name: "",
                sku_price: "",
                commodity_tag: ""
            })
        })

        // three_video资源位曝光埋点
        // var threeVideoExposure = new IntersectionObserver(enters => {
        //     enters.forEach(item =>{
        //         if (item.isIntersecting && !item.target.classList.contains("Exposured")) {
        //             let $this = $(item.target)
        //             let idx = $(".three_video .video_product").index($this) + 1 + ""
        //             sensors.track("mktExposure",{
        //                 mkt_page:"首页",
        //                 mkt_area:"fast_entrance",
        //                 mkt_position_number:idx,
        //                 mkt_material_id:"",
        //                 mkt_material_name:$this.find(".video_product_title").text().trim(),
        //                 sku_price:"",
        //                 commodity_tag:""
        //             })
        //             $this.addClass("Exposured")
        //             setTimeout(()=>{
        //               $this.removeClass("Exposured")
        //             },60000)
        //         }

        //     })
        // }, { threshold: [0.8] })
        // $(".three_video .video_product").each((i,dom)=>{
        //   threeVideoExposure.observe(dom)
        // })

        // CREATE THE MOMENT资源位点击
        $(".moment_message").on("click", ".message_box", (e) => {
            // e.preventDefault()
            let $this = $(e.target).parents(".message_box")
            let idx = $(".moment_message .message_box").index($this) + 1 + ""
            let mkt = {
                mkt_page: "首页",
                mkt_area: $this.parents(".moment_message").find(".section__this_header").text().trim(),
                mkt_position_number: idx,
                mkt_material_id: $this.find("a").attr("href"),
                mkt_material_name: $this.find(".user_name").text().trim(),
                sku_price: "",
                commodity_tag: ""
            }
            sensors.track("mktClick", mkt)
            RantionSetCookie(mkt.mkt_material_id, JSON.stringify({
                mkt_page: "首页",
                mkt_area: mkt.mkt_area,
                mkt_position_number: mkt.mkt_position_number,
                referer_page_type: "资源位",
                click_id: sensors.quick('getAnonymousID') + new Date().getTime() + mkt.mkt_material_id,
                referer_page: window.location.href,
            }))
        })

        // create the moment资源位曝光埋点
        // var momentExposure = new IntersectionObserver(enters => {
        //     enters.forEach(item =>{
        //         if (item.isIntersecting && !item.target.classList.contains("Exposured")) {
        //             let $this = $(item.target)
        //             let idx = $(".moment_message .message_box").index($this) + 1 + ""
        //             sensors.track("mktExposure",{
        //                 mkt_page:"首页",
        //                 mkt_area:$this.parents(".moment_message").find(".section__this_header").text().trim(),
        //                 mkt_position_number: idx,
        //                 mkt_material_id:$this.find("a").attr("href"),
        //                 mkt_material_name:$this.find(".user_name").text().trim(),
        //                 sku_price:"",
        //                 commodity_tag:""
        //             })
        //             $this.addClass("Exposured")
        //             setTimeout(()=>{
        //               $this.removeClass("Exposured")
        //             },60000)
        //         }

        //     })
        // }, { threshold: [0.8] })
        // $(".moment_message .message_box").each((i,dom)=>{
        //   momentExposure.observe(dom)
        // })


        // 首页flash deal js
        $("[data-section-type='flash_sale_section']").each((i, dom) => {
            console.log("1231231", i);
            let $this = $(dom)
            // let flashItem = $("[data-section-type='flash_sale_section'] .product-item")
            let flashItem = $this.find(".product-item")
            let flashCount = flashItem.length
            let flashNum = 0
            if (flashCount > 0) {
                flashCount--
            }
            let flashTabsTimes = Math.floor(flashCount / 5)
            $this.find(".arrow-l").on("click", () => {
                flashNum--;
                if (flashNum < 0) {
                    flashNum = 0
                }
                flashItem.css("transform", `translate(-${flashNum * 500}%)`);
                console.log(flashNum);
            })
            $this.find(".arrow-r").on("click", () => {
                flashNum++;
                if (flashNum > flashTabsTimes) {
                    flashNum = flashTabsTimes
                }
                flashItem.css("transform", `translate(-${flashNum * 500}%)`);
                console.log(flashNum);
            })

        })

        // flash deal 资源位点击,加入购物车埋点
        $("[data-section-type='flash_sale_section']").on("click", ".product-item", function (e) {
            let $this = $(this)
            let idx = $this.parent().find(".product-item").index($(this))
            let scookie = {
                mkt_page: "首页",
                mkt_area: $this.parents("[data-section-type='flash_sale_section']").find(".section__title").text().trim(),
                mkt_position_number: idx + 1 + '',
                mkt_material_id: $this.data("skuid"),
                mkt_material_name: $this.find(".flash-title").text().trim(),
                sku_price: $this.data("price") / 100,
                commodity_tag: $this.data("tag")
            }
            RantionSetCookie($this.data("productid"), JSON.stringify({
                mkt_page: scookie.mkt_page,
                mkt_area: scookie.mkt_area,
                mkt_position_number: scookie.mkt_position_number,
                referer_page_type: "资源位",
                referer_page: window.location.href,
                click_id: sensors.quick('getAnonymousID') + new Date().getTime() + scookie.mkt_material_id
            }))

            sensors.track("mktClick", scookie)


            if ($(e.target).hasClass('addToCart')) {
                // e.stopPropagation()
                let refererCookie = getRefererPageCookie($this.attr("data-productid"))
                trackWithProductInfo("AddToCart", {
                    ...refererCookie,
                    sku_id: $this.attr("data-skuid"),
                    sku_name: $this.find(".product_title a").text().trim(),
                    sku_price: $this.data("price") / 100,
                    commodity_tag: $this.attr("data-tag"),
                    sku_quantity: 1
                })
                // return
            }
        })
    }


    var mutationObserver = new MutationObserver(() => {
        $(".search-bar__result-products").on("click", "a", (e) => {
            // e.preventDefault()
            let $this = $(e.target).parents(".search-bar__result-item")
            if (!$this.length) {
                $this = $(e.target)
            }
            let count = $(".search-bar__result-products>a")
            let SearchResultClick = {
                key_word: $this.find(".search-bar__item-title").text(),
                keyword_type: "商品名推荐搜索词",
                result_number: count.length,
                position_number: count.index($this) + 1 + '',
                sku_id: $this.attr("data-skuid"),
                sku_name: $this.find(".search-bar__item-title").text(),
                sku_price: $this.data("price") / 100,
                commodity_tag: $this.attr("data-tag"),
            }
            // console.log(SearchResultClick);
            trackWithProductInfo('SearchResultClick', SearchResultClick)
            RantionSetCookie($this.attr("data-productid"), JSON.stringify({
                referer_page_type: "搜索结果",
                click_id: SearchResultClick.click_id,
                referer_page: window.location.href,
                key_word: SearchResultClick.key_word,
                keyword_type: SearchResultClick.keyword_type,
                click_id: sensors.quick('getAnonymousID') + new Date().getTime() + $this.data("skuid")
            }))

            sensors.track("ReturnSearchResult", {
                key_word: $(".search-bar__input.is-filled").val(),
                keyword_type: "商品名推荐搜索词",
                result_number: count.length,
            })
        })
    });
    mutationObserver.observe(document.querySelector('#search-popover>form'), {attributeFilter: ["class"]});


// 默认设置checkout付款
    sessionStorage.setItem("normalCheckout", 1)

    /*********************** events end ***********************/


    var activity_page_name = document.title
    $(".for_codeProduct_block a,.combo_feature_image a,.the_addToCart2,.combo_feature_image").on("click", (e) => {
        console.log('for_codeProduct_block')
        let $this = $(e.target).parents("a")
        console.log($this, '$this', encodeURIComponent($this.attr("href")))
        RantionSetCookie(`${encodeURIComponent($this.attr("href"))}`, JSON.stringify({
            referer_page_type: "活动页",
            referer_page: window.location.href,
            activity_page_name,
            click_id: sensors.quick('getAnonymousID') + new Date().getTime() + $this.attr("href")
        }))
    })


    $(".blog2-template").on("click", ".swiper-slide", function (e) {
        // e.preventDefault()
        const $this = $(this)
        const idx = $this.attr("data-swiper-slide-index") - 0
        const mkt = {
            mkt_page: "首页",
            mkt_area: $(".blog2-template").find(".section_title").text().trim(),
            mkt_position_number: idx + 1,
            mkt_material_id: $this.find("a").attr("href"),
            // mkt_material_name:$this.find(".user_name").text().trim(),
            sku_price: "",
            commodity_tag: ""
        }
        sensors.track("mktClick", mkt)
        RantionSetCookie(mkt.mkt_material_id, JSON.stringify({
            mkt_page: "首页",
            mkt_area: mkt.mkt_area,
            mkt_position_number: mkt.mkt_position_number,
            referer_page_type: "资源位",
            click_id: sensors.quick('getAnonymousID') + new Date().getTime() + mkt.mkt_material_id,
            referer_page: window.location.href,
        }))
    })

    $('.banner_arrow .arrow_left').click(function () {
        var pr = $(this).parents('.custom_banner_main')
        if(pr.length === 0){
          pr=  $(this).parents('.for_slideshow_block')
        }
        var dot = pr.find('.slideshow .flickity-page-dots .dot')
        if(dot.length === 0){
            dot =  pr.find('.for_slideshow_circles .for_circles_style')
        }
        const length = dot.length;
        let index = 0
        dot.each(function (i, dom) {
            if ($(dom).hasClass('is-selected') || $(dom).find('p').hasClass('for_current_style')) {
                index = i
            }
        })
        const nextIndex = index === 0 ? length - 1 : index - 1
        dot.eq(nextIndex).trigger("click");
    })
    $('.banner_arrow .arrow_right').click(function () {
        var pr = $(this).parents('.custom_banner_main')
            if(pr.length === 0){
                pr = $(this).parents('.for_slideshow_block')
            }

        var dot = pr.find('.slideshow .flickity-page-dots .dot')
            if(dot.length === 0){
                dot = pr.find('.for_slideshow_circles .for_circles_style')
            }

        const length = dot.length;
        let index = 0
        dot.each(function (i, dom) {
            if ($(dom).hasClass('is-selected') || $(dom).find('p').hasClass('for_current_style')) {
                index = i
            }
        })
        console.log(dot, index)
        const nextIndex = index === length - 1 ? 0 : index + 1
        dot.eq(nextIndex).trigger("click");
    })
})
